export default "__VITE_ASSET__BDTO9fJN__"